import React from 'react';
import CopyText from 'react-copy-text'
// import { createMuiTheme } from '@material-ui/core/styles';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { connect } from 'react-redux';
/* application components */
import { Header } from '../../components/Header';
import PropTypes from "prop-types";
import muitheme from '../../theme/muiTheme'
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/auth';

function mapStateToProps(state) {
    return {
        userName: state.auth.userName,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

@connect(mapStateToProps, mapDispatchToProps)
class App extends React.Component { // eslint-disable-line react/prefer-stateless-function
    static propTypes = {
        children: PropTypes.node,
    };
    state = {textToCopy: ''}
 
    onButtonClick = () => this.setState({ textToCopy: 'NOW: ' + Date.now() })
    onCopied = (text) => console.log(`${text} was copied to the clipboard`)

    componentWillMount = (props) => {
        if(this.props.isAuthenticated){
            console.log('esa logeado')
            browserHistory.push('/main')
        } else{
            browserHistory.push('/login')
        }
       
    }


    render() {
        return (
            <MuiThemeProvider theme={muitheme}>
                <section>
                    <Header />
                    <div
                        className="container"
                        style={{ marginTop: 10, paddingBottom: 250 }}
                    >
                        {this.props.children}
                    </div>
                </section>
            </MuiThemeProvider>
        );
    }
}

export { App };



// WEBPACK FOOTER //
// ./src/containers/App/index.js